import { render, staticRenderFns } from "./ProfileProducts.vue?vue&type=template&id=11f97e83&"
import script from "./ProfileProducts.vue?vue&type=script&lang=js&"
export * from "./ProfileProducts.vue?vue&type=script&lang=js&"
import style0 from "./ProfileProducts.vue?vue&type=style&index=0&id=11f97e83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports